/**
 * @generated SignedSource<<5706632d4fd40698bee305a200c930e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueTableHideDoneToggle_HideDoneItemsToggle_project$data = {
  readonly projectId?: string | null | undefined;
  readonly " $fragmentType": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_project";
};
export type ui_issueTableHideDoneToggle_HideDoneItemsToggle_project$key = {
  readonly " $data"?: ui_issueTableHideDoneToggle_HideDoneItemsToggle_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableHideDoneToggle_HideDoneItemsToggle_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectId"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c53493c6a77b920bde17eb0cc455b1bc";

export default node;
